import { CardRenderer } from '@/components/elements/Card';
import { EmblaCarousel } from '@/components/elements/Carousel/Carousel';
import Container from '@/components/global/Container';
import { IComponentBlocksCarouselStories, IStory } from '@/graphql/__generated__/global/types';
import { CardImageAspectRatio } from '@/helpers/determineAspectRatioByCardSpan';
import { findFullSlug } from '@/lib/strapiQueries';

export const LeftSlider = ({ stories }: IComponentBlocksCarouselStories) => {
    return (
        <Container paddingX={false} maxWidth="xl">
            <EmblaCarousel
                emblaOptions={{
                    slidesToScroll: 'auto',
                    containScroll: 'trimSnaps',
                }}
            >
                {({ emblaRef }) => {
                    return (
                        <>
                            <EmblaCarousel.Slides ref={emblaRef} className="embla__carousel__stories">
                                {stories &&
                                    stories.data?.length > 0 &&
                                    stories.data?.map((card, index) => {
                                        const { hero } = card.attributes as IStory;
                                        const { title, description, image, video } = hero ?? {};

                                        const { playback_id } = video?.backgroundVideo?.data?.attributes ?? {};
                                        let hoverImage;
                                        let thumbnail;

                                        if (playback_id) {
                                            // Start time is set to 10s to avoid the first frame of the video
                                            hoverImage = `https://image.mux.com/${playback_id}/animated.webp?start=10&width=480&fps=24`;
                                        }

                                        if (!image && playback_id) {
                                            thumbnail = `https://image.mux.com/${playback_id}/thumbnail.webp?width=480&fps=24`;
                                        }

                                        const slug = findFullSlug(card).join('/');

                                        const link = {
                                            id: card.id as string,
                                            linkToExternalPage: slug,
                                            label: 'Read More',
                                        };

                                        return (
                                            <div className="embla__slide" key={index}>
                                                <CardRenderer
                                                    card={{
                                                        title,
                                                        description,
                                                        image: image?.image || thumbnail,
                                                        hoverImage: hoverImage,
                                                        eyebrowText: 'Story guide',
                                                        link,
                                                        aspectRatio: CardImageAspectRatio.wide,
                                                        sizes: `(max-width: 639px) 80vw, (max-width: 1919px) 90vw, 1684px`,
                                                    }}
                                                />
                                            </div>
                                        );
                                    })}
                            </EmblaCarousel.Slides>
                        </>
                    );
                }}
            </EmblaCarousel>
        </Container>
    );
};

export default LeftSlider;
